<button class="chaicom-btn chaicom-btn--green chaicom-btn--full-width" @click="callWaiter">{{ $t('Викликати офіціанта') }}</button>